import React from 'react';
import PropTypes from 'prop-types';
import Query from 'apps/admin/util/query';
import { jsonToInputParams } from 'library/util/graph';
import Toggle from 'library/components/form-elements/toggle';

import 'apps/admin/styles/components/direct_invoice.scss';

class DirectInvoiceForm extends React.Component {
  state = {
    contact_email: '',
    cost: '',
    billing_date: '',
    status: '',
    loaded: false
  }

  static getDerivedStateFromProps(props, state) {
    if (!props.edit || state.loaded) return;

    return {
      contact_email: props.data.contact_email || '',
      cost: props.data.cost || '',
      billing_date: props.data.billing_date || '',
      status: props.data.status === 'active' ? true : false,
      loaded: true
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;

    this.setState({
      [name]: value
    });
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    const {
      contact_email,
      cost,
      billing_date,
      status
    } = this.state;

    const {
      data,
      organizationId,
      edit,
      appName,
      reload
    } = this.props;

    const queryHeader = edit ? 'update_direct_invoice' : 'create_direct_invoice';
    const daStatus = status ? 'active' : 'canceled';

    const params = {
      organization_id: Number(organizationId),
      product_name: appName,
      contact_email,
      cost: Number(cost),
      billing_date: Number(billing_date),
      status: daStatus
    };

    if (edit) params['id'] = data.id;

    try {
      const mutationData = await Query(`
        mutation {
          ${queryHeader}(${jsonToInputParams(params)}) {
            success,
            errors
          }
        }
      `);

      if (mutationData.data[`${queryHeader}`].success) reload(true);

    } catch (e) {
      console.error(e);
    }
  }

  render() {
    const {
      onClose,
      edit,
      appName,
    } = this.props;

    const {
      contact_email,
      cost,
      billing_date,
      status
    } = this.state;

    return (
      <div className="hiring-modal">
        <div className="hiring-modal-header">
          <div className="hiring-modal-header-inner">
            <h1> {edit ? 'Edit' : 'Create'} Direct Invoice </h1>
            <a onClick={() => onClose()} href="javascript:void(0)">×</a>
          </div>
          <svg className="hiring-modal-header-svg" width="100%" height="20px" viewBox="0 0 100 50" preserveAspectRatio="none">
            <path className="hiring-modal-header-svg-first" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 100,50 0,0`}></path>
            <path className="hiring-modal-header-svg-second" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 0,50 0,0`}></path>
          </svg>
        </div>
        <div className="hiring-modal-body">
          <form onSubmit={this.handleSubmit}>
            <label>
            Product
              <select name='product_name' value={appName} onChange={this.handleChange}>
                <option value='hiring'> Hiring </option>
                <option value='pathways'> Pathways </option>
                <option value='pro'> Pro </option>
              </select>
            </label>

            <label>
              Contact Email
              <input name='contact_email' type='text' value={contact_email} onChange={this.handleChange}/>
            </label>

            <label>
              Cost
              <input name='cost' type='text' value={cost} onChange={this.handleChange}/>
            </label>

            <label>
              Billing Date
              <input name='billing_date' type='text' value={billing_date} onChange={this.handleChange}/>
            </label>

            <label className='direct-invoice-form-status'>
              Status
              <Toggle
                onChange={this.handleChange}
                checked={status}
                name="status"
              />
            </label>

            <button type='submit'> {edit ? 'Edit Data Invoice' : 'Create dat Invoice'} </button>
          </form>
        </div>
      </div>
    );
  }
}

DirectInvoiceForm.propTypes = {
  onClose: PropTypes.func,
  edit: PropTypes.bool,
  data: PropTypes.object,
  organizationId: PropTypes.number,
  appName: PropTypes.string,
  reload: PropTypes.func
};

export default DirectInvoiceForm;
